import CartDeliveryInfoNew from './CartDeliveryinfoNew'

export default CartDeliveryInfoNew
